import _property from 'lodash/property';

var city = _property('city');

var country = _property('country');

var state = _property('state');

var line1 = _property('line1');

var VENDOR_ADDRESS = {
  city: city,
  country: country,
  state: state,
  line1: line1
};
export default VENDOR_ADDRESS;